import { createSelector } from 'reselect'
import { IRootState } from '../reducer'
import { prefix } from './actions'
import { getCellLinksKey } from './reducer'

export const getCellNotesState = (state: IRootState) => state[prefix]

/**
 * When this table last had a note saved leaving suggestions still being segmented. The table
 * refetches its markers after this changes, since those suggestions are withheld until ready.
 * Scoped to the table so one table's pending work never makes every other one poll.
 */
export const getSegmentationPendingForTable = (tableType: string, clientId: string) =>
  createSelector(
    [getCellNotesState],
    (cellNotesState) => cellNotesState.segmentationPendingByTable[`${tableType}|${clientId}`],
  )

export const getCellNoteLinksForCell = (
  tableType: string,
  rowId: string,
  columnId: string,
  recordDate?: string | null,
) =>
  createSelector([getCellNotesState], (cellNotesState) => {
    const key = getCellLinksKey(tableType, rowId, columnId, recordDate)
    return cellNotesState.linksByCell[key]?.data?.links || []
  })

export const getCellAuthoredNotesForCell = (
  tableType: string,
  rowId: string,
  columnId: string,
  recordDate?: string | null,
) =>
  createSelector([getCellNotesState], (cellNotesState) => {
    const key = getCellLinksKey(tableType, rowId, columnId, recordDate)
    return cellNotesState.linksByCell[key]?.data?.notes || []
  })

export const getCellNoteLinksLoadingForCell = (
  tableType: string,
  rowId: string,
  columnId: string,
  recordDate?: string | null,
) =>
  createSelector([getCellNotesState], (cellNotesState) => {
    const key = getCellLinksKey(tableType, rowId, columnId, recordDate)
    return cellNotesState.linksByCell[key]?.isLoading || false
  })

export const getCellNoteIndicatorsForTable = (tableType: string, clientName: string) =>
  createSelector([getCellNotesState], (cellNotesState) => {
    const tableKey = `${tableType}|${clientName}`
    return cellNotesState.indicatorsByTable[tableKey]?.data || null
  })

export const getCellNoteIndicatorsLoadingForTable = (tableType: string, clientName: string) =>
  createSelector([getCellNotesState], (cellNotesState) => {
    const tableKey = `${tableType}|${clientName}`
    return cellNotesState.indicatorsByTable[tableKey]?.isLoading || false
  })

export const getCellNoteIndicatorsByPositionForTable = (tableType: string, clientName: string) =>
  createSelector([getCellNoteIndicatorsForTable(tableType, clientName)], (indicatorsData) => {
    return indicatorsData?.indicatorsByCell || {}
  })
